import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { CardBox, SplitPanel, Centered, RightCornerIcon } from "../CardsStyled";
import StatusIcon from "../../Icons/StatusIcon";
import CalendarIcon from "../../Icons/CalendarIcon";
import CardCore from "../CardCore";
import { useTranslate } from "hooks/translation-hooks";
import { hideEventDateOnAppointmentDeclinedSelector } from "redux/selectors/config";

export const AppointmentDeclined = ({
  description,
  appointmentDeclinedAt,
  appointmentProposalStart,
  appointmentProposalEnd
}) => {
  const hideDate = useSelector(hideEventDateOnAppointmentDeclinedSelector);
  const t = useTranslate();
  return (
    <CardBox
      data-testid="appointment_declined_card"
      data-category="appointment_declined"
    >
      <SplitPanel>
        <Centered>
          <RightCornerIcon>
            <StatusIcon status="DELAYED" />
          </RightCornerIcon>
          <CalendarIcon />
        </Centered>
        <CardCore
          title={t("history_appointment_declined_card-title")}
          additionalDescription={t("history_appointment_declined_card-text_1")}
          description={description}
          rawEventDate={appointmentDeclinedAt}
          appointmentProposalStart={appointmentProposalStart}
          appointmentProposalEnd={appointmentProposalEnd}
          statusClass="error"
          hideDate={hideDate}
        />
      </SplitPanel>
    </CardBox>
  );
};

AppointmentDeclined.propTypes = {
  description: PropTypes.string.isRequired,
  rawEventDate: PropTypes.string.isRequired
};

export default AppointmentDeclined;
